export default __webpack_public_path__ + "static/media/bg-square-shape-right-min.1e39d524.png";